import { render, staticRenderFns } from "./QuoteForm.vue?vue&type=template&id=23ff18c0&scoped=true&"
import script from "./QuoteForm.vue?vue&type=script&lang=ts&"
export * from "./QuoteForm.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteForm.vue?vue&type=style&index=0&id=23ff18c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff18c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
